import type { ReactNode } from 'react';

type Tom = 'neutro' | 'destaque' | 'marca' | 'aviso' | 'ok';

const TONS: Record<Tom, string> = {
  neutro: 'border-borda-forte text-apagado',
  destaque: 'border-transparent bg-destaque-fundo text-destaque-texto',
  marca: 'border-transparent bg-marca text-sobre-marca',
  aviso: 'border-aviso/40 text-aviso',
  ok: 'border-ok/40 text-ok',
};

/** Etiqueta retangular. Substitui o "selo" em pilula. */
export function Etiqueta({ children, tom = 'neutro' }: { children: ReactNode; tom?: Tom }) {
  return (
    <span
      className={`inline-flex h-5 items-center rounded-(--radius-controle) border px-1.5 text-xs font-semibold tracking-wide whitespace-nowrap uppercase ${TONS[tom]}`}
    >
      {children}
    </span>
  );
}
